import React, { useState, useRef } from "react";
import Loader from "../../components/styled-components/loader/loader";
import { FormInputGroup } from "../../components/formInputGroup/FormInputGroup";
import PhoneNumber from "../../components/form/components/Countrycode";
import { FormInput } from "../../components/formInput/FormInput";
import { useHistory, useLocation } from "react-router-dom";
import fileUploadIcon from "../../assets/SVGs/Vector.svg";
import { Button, Checkbox, Divider } from "antd";
import Tap from "@tapfiliate/tapfiliate-js";
import ROUTES from "../../config/routes";
import Base64 from "../../utils/base64";
import moment from "moment";
import swal from "sweetalert";
import axios from "axios";
import "./SignupV2.css";
import { Icon } from "antd";
import { MODULE_API } from "../../apis";
import { setAddClientButton } from "../../redux/slices/financialAdvisorSlice";
import { useDispatch } from "react-redux";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

const SignupV2 = () => {
  const [selected, setSelected] = useState("consumer");
  const fileInputRef = useRef(null);
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    repassword: "",
    zipCode: "",
    profilePicture: null,
    primarySupportStaffName: "",
    primarySupportStaffEmail: "",
    secondarySupportStaffName: "",
    secondarySupportStaffEmail: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };

  const [userData, setUserData] = useState({});
  const dispatch = useDispatch()

  const history = useHistory();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSignup();
    }
  };

  const handleSignup = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("ref");
    console.log("code", code);
    const defaultSetting = {
      showOnboardingWidget: true,
      onboardingSteps: {},
      dragDrop: [
        {
          id: "budgetExpanse",
        },
        {
          id: "dashboardBudgetSection",
        },
        {
          id: "dashboardSavingSection",
        },
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
        {
          id: "dashboardGoalSection",
        },
      ],
      dragCards: [
        {
          id: "budgetExpanse",
        },
        {
          id: "dashboardBudgetSection",
        },
        {
          id: "dashboardSavingSection",
        },
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
        {
          id: "dashboardGoalSection",
        },
      ],
      dashboard1DragCards: [
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
      ],
      dashboard2DragCards: [
        {
          id: "DashboardCalendar",
        },
      ],
      dashboard3DragCards: [
        {
          id: "topMonthlyExpanse",
        },
        {
          id: "goalProgress",
        },
        {
          id: "dashboardGoalCharts",
        },
      ],
    };
    if (formData.password !== formData.repassword) {
      swal("Oops!", "Passwords do not match", "error");
    } else if (
      formData &&
      formData.name &&
      formData.username &&
      formData.username.length >= 3 &&
      formData.password &&
      formData.email &&
      formData.phone
    ) {
      const payload = {
        name: formData.name,
        userName: formData.username,
        password: formData.password,
        email: formData.email,
        phoneNumber: formData.phone,
        zipCode: +formData.zipCode,
        roles:
          selected === "advisor"
            ? ["dashboard_financial_advisor"]
            : ["consumer_dashboard"],
        alpha2Code: "US",
        image: formData.image ? formData.image : null,
        appJoiningDate: moment().format("MMDDYY"),
        source: "Web",
        tapfiliateRefCode: code && code,
        tapfiliateLink: code && `${window.location}`,
        setting: defaultSetting,
        // Conditionally add fields only if selected is 'advisor'
        // ...(selected === "advisor" && {
        //   primarySupportStaffName: formData.primarySupportStaffName,
        //   primarySupportStaffEmail: formData.primarySupportStaffEmail,
        //   secondarySupportStaffName: formData.secondarySupportStaffName,
        //   secondarySupportStaffEmail: formData.secondarySupportStaffEmail,
        //   profilePhoto: formData.profilePicture,
        // }),
      };

      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/auth/signup`,
          payload,
          config
        );
        setLoading(false);
        if (res.status === 200) {
          if(selected === 'advisor'){
            dispatch(setAddClientButton(true))
          }
          await handleAutoLogin();
          swal("Success!", res.data.message, "success");
          if (code) {
            Tap.customer(userData.name);
          }
          // Tap.conversion(userData.name, 30.0);
        }
      } catch (error) {
        setLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          console.log("eroor", error.response.data.message);
          swal("Oops!", error.response.data.message, "error");
        }
      }
    } else {
      swal(
        "Oops!",
        (formData && !formData.name && "Please enter a valid Name") ||
        (formData && (!formData.username || formData.username.length < 3) && "Please enter a valid Username (min 3 characters, no spaces)") ||
          (formData && !formData.email && "Please enter valid email address") ||
          (formData && !formData.phone && "Please enter valid Phonenumber") ||
          (formData && !formData.password && "Please enter valid Password"),
        "error"
      );
    }
  };
  const inactiveRoles = ["inActive financial adviser client", "inActive Financial Advisor", "inactiveClient"]
  const userRoles = ["Financial Advisor", "Active Financial Advisor"]

  const handleAutoLogin = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${ROUTES.BASE_URL}/auth-service/auth/signin`,
        {
          username: formData.username,
          password: formData.password,
        },
        config
      );
      setLoading(false);
      let outputObj = {};
      if (res.status === 200 && res.data.access_token) {
        if (res.data.user.roles) {
          const loginRole = res.data.user.roles;
          console.log("loginRole", loginRole);
          if (loginRole) {
            let recursive = (obj, name) => {
              for (let key in obj) {
                if (typeof obj[key] == "object") {
                  recursive(obj[key], name + "_" + key);
                } else {
                  outputObj[key] = obj[key];
                }
              }
            };
            recursive(loginRole, "loginRole");
            localStorage.setItem("role", JSON.stringify(outputObj.name));
          }
        }
        localStorage.setItem("userData", JSON.stringify(res.data.user));
        localStorage.setItem("User", res.data.user.name);
        localStorage.setItem("userName", res.data.user.userName);
        if (res.data.user.image !== null) {
          localStorage.setItem("profile", res.data.user.image);
        }
        localStorage.setItem("userLoginToken", res.data.access_token);

        if (res.data.user.permissions) {
          let permissions = res.data.user.permissions;
          const namesArray = Object.values(permissions).map(
            (permission) => permission.name
          );
          localStorage.setItem("permissionState", JSON.stringify(namesArray));
        }

        if (res.data.access_token) {
          if (
            location.state &&
            location.state.from &&
            location.state.from.pathname
          ) {
            history.push({
              pathname: location.state.from.pathname,
              state: { from: location.state.from },
              PathExact: location.PathExact,
            });
          } else {
            if (inactiveRoles.includes(outputObj.name)) {
              history.push("/payment");
            } else if (userRoles.includes(outputObj.name)) {
              // history.push("/dashboard");
              history.push("/free-trial");
            } else {
              history.push("/free-trial");
            }
          }
        }
      }
    } catch (error) {
      setLoading(false);
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        swal("Oops!", error.response.data.message, "error");
      }
      console.log(error);
    }
  };

  const handleTabChange = (type) => {
    setSelected(type);
    setFormData({
      ...formData,
      primarySupportStaffName: "",
      primarySupportStaffEmail: "",
      secondarySupportStaffName: "",
      secondarySupportStaffEmail: "",
      profilePicture: "",
    });
  };

  const handleImageUpload = async (event) => {
    event.preventDefault();

    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formDataFile = new FormData();
      formDataFile.append("file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadProfilePicture({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload =
        resdata &&
        (await axios.put(resdata.uploadUrl, uploadFile, {
          headers: { "Content-type": uploadFile.type },
        }));
      const res = resdata && resdata.uploadUrl.split("?")[0];
      setLoading(false);
      setFormData({
        ...formData,
        ["image"]: res,
      });
    }
  };

  const renderFormInput = (
    label,
    name,
    type = "text",
    placeholder = "",
    required = false
  ) => {
    const isPasswordField = name === "password";
    const isRePasswordField = name === "repassword";

    const inputType = isPasswordField
      ? showPassword
        ? "text"
        : "password"
      : isRePasswordField
      ? showRePassword
        ? "text"
        : "password"
      : type;

    const toggleIcon = () => {
      if (isPasswordField) {
        setShowPassword((prev) => !prev);
      } else if (isRePasswordField) {
        setShowRePassword((prev) => !prev);
      }
    };
    return (
      <FormInputGroup>
        <label>
          {label}
          {required && <span style={{ color: "red" }}>*</span>}
        </label>
        <FormInput
          id={name}
          type={inputType}
          placeholder={placeholder || label}
          name={name}
          required={required}
          value={formData[name]}
          // onChange={(e) => {
          //   setFormData({ ...formData, [name]: e.target.value });
          // }}
          onChange={(e) => {
            let value = e.target.value;
            // Prevent spaces in username
            if (name === "username") {
              value = value.replace(/\s/g, "");
            }
            setFormData({ ...formData, [name]: value });
          }}
          onKeyDown={(e) => {
            if (name === "username" && e.key === " ") {
              e.preventDefault();
            }
          }}
        />
        {(isPasswordField || isRePasswordField) && (
          <Icon
            type={
              (isPasswordField && showPassword) ||
              (isRePasswordField && showRePassword)
                ? "eye-invisible"
                : "eye"
            }
            className="pass-eye-icon"
            onClick={toggleIcon}
          />
        )}
      </FormInputGroup>
    );
  };

  return (
    <div className="login-card-main" style={{ marginTop: "20px", marginBottom: "1rem" }}>
      <div className="signup-card border">
        <div className="signup-container">
          <h2 className="signup-heading">Sign Up</h2>
          <div className="toggle-container">
            {["advisor", "consumer"].map((type) => (
              <button
                key={type}
                className={`toggle-btn ${selected === type ? "active" : ""}`}
                onClick={() => {
                  handleTabChange(type);
                }}>
                {type === "advisor" ? "Professional Advisor" : "Consumer"}
              </button>
            ))}
          </div>
        </div>

        <div className="feild-container">
          {renderFormInput("Name", "name", "text", "Name", true)}
          {renderFormInput("Username", "username", "text", "Username", true)}
        </div>

        <div className="feild-container">
          {renderFormInput(
            "Email Address",
            "email",
            "email",
            "Email Address",
            true
          )}
          <FormInputGroup className="hehe">
            <label>
              Phone Number<span style={{ color: "red" }}>*</span>
            </label>
            <PhoneNumber
              id="phone"
              name="phone"
              onKeyPress={handleKeyPress}
              // value={formData.phone}
              onChange={(value) =>
                setFormData({ ...formData, phone: value.target.value })
              }
              size="large"
              placeholder="Phone Number"
            />
          </FormInputGroup>
        </div>

        <div className="feild-container">
          {renderFormInput(
            "Password",
            "password",
            "password",
            "Password",
            true
          )}
          {renderFormInput(
            "Re-enter Password",
            "repassword",
            "password",
            "Re-enter Password",
            true
          )}
        </div>

        <div className="feild-container">
          {renderFormInput("Zip Code", "zipCode")}
          <FormInputGroup>
            <label>Upload Profile Picture</label>
            <div className="file-upload-wrapper">
              {/* <input
                type="file"
                id="profilePicture"
                name="profilePicture"
                accept="image/*"
                onChange={(e) => {
                  // console.log(e.target.files[0]);
                  handleImageUpload(e);
                }}
                className="file-input"
              />
              <label htmlFor="profilePicture" className="file-label">
                {formData.image ? "Uploaded" : "Choose from files"}
              </label>
              <button
                type="button"
                className="upload-btn"
                onClick={() =>
                  fileInputRef.current && fileInputRef.current.click()
                }
              >
                <img src={fileUploadIcon} alt="fileUploadIcon" />
              </button> */}
              <label
                htmlFor="profilePicture"
                className="upload-btn"
                style={{
                  cursor: "pointer",
                  width: "92%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "0px",
                }}>
                <input
                  type="file"
                  ref={fileInputRef}
                  // style={{ display: "none" }}
                  id="profilePicture"
                  name="profilePicture"
                  accept="image/*"
                  onChange={(e) => {
                    console.log(e.target.files[0]);
                    handleImageUpload(e);
                  }}
                />
                <img src={fileUploadIcon} alt="Upload" />
              </label>
            </div>
          </FormInputGroup>
        </div>

        {selected == "advisor" && (
          <div className="feild-container">
            {renderFormInput(
              "Primary Support Staff Name",
              "primarySupportStaffName",
              "text",
              "John Deo"
            )}
            {renderFormInput(
              "Primary Support Staff Email",
              "primarySupportStaffEmail",
              "email",
              "johndeo@gmail.com"
            )}
          </div>
        )}

        {selected == "advisor" && (
          <div className="feild-container">
            {renderFormInput(
              "Secondary Support Staff Name",
              "secondarySupportStaffName",
              "text",
              "James"
            )}
            {renderFormInput(
              "Secondary Support Staff Email",
              "secondarySupportStaffEmail",
              "email",
              "james@gmail.com"
            )}
          </div>
        )}

        <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
          <label style={{ display: "flex" }}>
            <Checkbox
              className="subtext"
              onChange={() => {
                setIsChecked(!isChecked);
              }}>
              I Agree to the{" "}
              <a
                style={{ color: "#2A3DA3" }}
                href="https://assetplanet.com/privacy-policy/"
                target="_blank">
                Privacy policy, Terms and Conditions
              </a>
            </Checkbox>
          </label>
        </div>

        <Button
          className="sign-up-button"
          disabled={!isChecked}
          onClick={() => {
            handleSignup();
          }}>
          Sign Up
        </Button>
        <Divider />

        <div className="links">
          <span className="subtext">
            Are You Client?{" "}
            <a
              style={{ color: "#2A3DA3" }}
              className="subtext-href"
              href="/login">
              Login Here
            </a>
          </span>
          <span className="subtext" style={{display:"flex"}}>
            Are You a Trusted Individual?{" "}<ToolTipCreator name="Are_You_Trusted_Individual" />
            <a style={{ color: "#2A3DA3" }} href="/trusteeLogin">
              Login Here
            </a>
          </span>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
};

export default SignupV2;
